const LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
const LOCAL_STORAGE_DELIMITER = ",";
const BUTTON_ACTIVE_CLASS = "active";
const GRID_LOADED_CLASS = "loaded";

const selectors = {
  button: "[button-wishlist]",
  grid: "[grid-wishlist]",
  productCard: ".product-wishlist",
};

document.addEventListener("DOMContentLoaded", () => {
  initButtons();
  initGrid();
  updateWishlistCount(); // Explicitly call to update count on page load
});

document.addEventListener("shopify-wishlist:updated", (event) => {
  console.log("[Shopify Wishlist] Wishlist Updated ✅", event.detail.wishlist);
  initGrid();
});

document.addEventListener("shopify-wishlist:init-product-grid", (event) => {
  console.log(
    "[Shopify Wishlist] Wishlist Product List Loaded ✅",
    event.detail.wishlist
  );
});

document.addEventListener("shopify-wishlist:init-buttons", (event) => {
  console.log(
    "[Shopify Wishlist] Wishlist Buttons Loaded ✅",
    event.detail.wishlist
  );

  /**
   * after customer logged
   * check cookie and set wishlist
   * when done, delete cookie
   * editby: ntran
   */
  let pWishlist = getCookie('pWishlist');
  if(pWishlist && theme.customerLogin){
    console.log('set wishlist by cookie');
    updateWishlist(pWishlist);
    deleteCookie('pWishlist');
  }
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=product-wishlist`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, "text/html");
      const productCard = htmlDocument.documentElement.querySelector(
        selectors.productCard
      );
      return productCard.outerHTML;
    })
    .catch((err) => {   
      let wishlist = getWishlist();
      if(wishlist.length){
        let indexInWishlist = wishlist.indexOf(handle);
    
        wishlist.splice(indexInWishlist, 1);
        setWishlist(wishlist);
      }
      
      console.error(
        `[Shopify Wishlist] Failed to load content for handle: ${handle}`,
        err
      )
    });
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join("");
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent("shopify-wishlist:init-product-grid", {
    detail: { wishlist: wishlist },
  });
  addToCart();
  document.dispatchEvent(event);
};

const addToCart = () => {
    $('.product-whist-form').submit(function(e){
      e.preventDefault();

      const cartDrawer = document.querySelector('cart-drawer');
      const overlay = document.getElementById('cart-drawer').querySelector('.overlay');
      const formData = new FormData();
      var form_data = $(this).serializeArray();
      $.each(form_data, function (key, input) {
        formData.append(input.name, input.value);
      });

      let sections = 'cart-icon-bubble';
      if (cartDrawer) {
        sections += `,${cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }
      formData.append('sections_url', $(this).find('input#product_url').val());
      formData.append('sections', sections);

      fetch(theme.routes.cartAdd+'.js', {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
      .then(res => res.json())
      .then(response => {
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble) {
          cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
        }
        setTimeout(() => {
          const quickAddDrawer = document.querySelector('quick-add-drawer');
          if (cartDrawer) {
            cartDrawer.renderContents(
              response,
              true
            );

          } else if (window.location.pathname === theme.routes.cart) {
            const cartItems = document.querySelector('cart-items');
            if (cartItems) {
              if (cartItems.dataset.empty === 'true') {
                window.location.reload();
              } else {
                cartItems.refresh();
              }
            }
          }
        }, 700);

        fetch(`${theme.routes.cart}.js`)
        .then(oldCartResponse => oldCartResponse.json())
        .then(oldCartData => {
          fetch(`${theme.routes.cart}.js`)
          .then(newCartResponse => newCartResponse.json())
          .then(newCartData => {
            const itemInOldCart = oldCartData.items.filter(
              (item) => item.variant_id === response.variant_id
            )[0];
  
            // Check if product was already in the cart
            if (itemInOldCart) {
              document.dispatchEvent(new CustomEvent('on:line-item:change', {
                bubbles: true,
                detail: {
                  cart: newCartData,
                  variantId: response.variant_id,
                  oldQuantity: itemInOldCart.quantity,
                  newQuantity: (itemInOldCart.quantity === response.quantity)
                    ? itemInOldCart.quantity : response.quantity
                }
              }));
            } else {
              document.dispatchEvent(new CustomEvent('on:cart:add', {
                bubbles: true,
                detail: {
                  cart: newCartData,
                  variantId: response.variant_id
                }
              }));
            }

          });
        })
      });
    });
}

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle)
      return console.error(
        "[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
      );
    if (wishlistContains(productHandle))
      button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener("click", () => {
      /**
       * Check customer logged
       * if no then redirect to page login
       * if yes then add wishlist
       * edit by: ntran
       */
      if(theme.customerLogin){
        updateWishlist(productHandle);
        button.classList.toggle(BUTTON_ACTIVE_CLASS);
      }
      else{
        setCookie('pWishlist', productHandle);
        setTimeout(() => {
          window.location.href = theme.routes.accountLogin;
        }, 300);
      }
    });
  });
};

const updateWishlistCount = () => {
  const wishlistIcons = document.querySelectorAll(".header__icons .wishlist");
  const wishlist = getWishlist();

  wishlistIcons.forEach((wishlistIcon) => {
    const countElement = wishlistIcon.querySelector(".wishlist-count");
    if (countElement) {
      countElement.textContent = wishlist.length; // Update count
    }

    if ((wishlist.length > 0) && theme.customerLogin) {
      wishlistIcon.classList.add("active"); // Add active class if wishlist is not empty
    } else {
      wishlistIcon.classList.remove("active"); // Remove active class if wishlist is empty
    }
  });
  // If wishlist is empty, display a message on the wishlist page
  const wishlistPageMessage = document.querySelector(".wishlist-page-message");
  if (wishlist.length === 0 && wishlistPageMessage) {
    wishlistPageMessage.textContent = "There are no products in your wishlist.";
    wishlistPageMessage.style.display = "block"; // Show the message
  } else if (wishlistPageMessage) {
    wishlistPageMessage.style.display = "none"; // Hide the message if there are items
  }
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);

  updateWishlistCount(); // Update count after initializing buttons

  const event = new CustomEvent("shopify-wishlist:init-buttons", {
    detail: { wishlist: getWishlist() },
  });
  document.dispatchEvent(event);
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);

  updateWishlistCount(); // Update count after initializing grid
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent("shopify-wishlist:updated", {
    detail: { wishlist: array },
  });
  document.dispatchEvent(event);

  updateWishlistCount(); // Ensure count updates after wishlist changes

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

function deleteCookie(name){
  let expires = '';
  document.cookie = `${encodeURIComponent(name)}=${expires}; path=/; SameSite=None; Secure`;
}